import BaseService from "../baseService";
class EmpresaFilial extends BaseService {
  constructor(id) {
    const resource = "empresa-filial";
    let relationship = {};
    super(id, relationship, resource);
  }
}

export default (id) => new EmpresaFilial(id);
